
/**
 * 심리 검사 유형별 정보 및 점수 해석 로직
 */

export interface TestInfo {
  id: string;
  title: string;
  description: string;
  path: string;
}

export const TESTS: TestInfo[] = [
  {
    id: 'phq-9',
    title: '우울증 자가 진단 (PHQ-9)',
    description: '지난 2주 동안의 기분 상태를 점검하여 우울 증상 수준을 확인합니다.',
    path: '/tests/phq-9',
  },
  {
    id: 'gad-7',
    title: '불안 척도 (GAD-7)',
    description: '지난 2주 동안의 불안 증상을 점검하여 불안 수준을 확인합니다.',
    path: '/tests/gad-7',
  },
  {
    id: 'pss',
    title: '스트레스 자가 척도 (PSS)',
    description: '지난 한 달간 경험한 스트레스 수준을 평가합니다.',
    path: '/tests/pss',
  },
  {
    id: 'rses',
    title: '자존감 척도 (RSES)',
    description: '자신에 대한 긍정적, 부정적 평가를 통해 전반적인 자존감 수준을 측정합니다.',
    path: '/tests/rses',
  },
  {
    id: 'pcl-5',
    title: '외상 후 스트레스 척도 (PCL-5)',
    description: '충격적인 사건 경험 후 겪을 수 있는 스트레스 반응을 평가합니다.',
    path: '/tests/pcl-5',
  },
  {
    id: 'bdi',
    title: '벡 우울 척도 (BDI)',
    description:
      '우울증의 인지적, 정서적, 신체적 증상을 포함한 21개 문항을 통해 우울 수준을 측정합니다.',
    path: '/tests/bdi',
  },
];

export const getTestTitle = (testType: string | null): string => {
  const test = TESTS.find((t) => t.id === testType);
  return test ? test.title : '심리 검사';
};

export const getScoreInterpretation = (testType: string | null, score: number): string => {
  switch (testType) {
    case 'phq-9':
      if (score <= 4) return '우울 증상이 거의 없거나 최소한의 수준입니다.';
      if (score <= 9) return '경미한 우울 증상을 보이고 있습니다. 주의 깊은 관찰이 필요합니다.';
      if (score <= 14) return '중간 수준의 우울 증상이 의심됩니다. 전문가 상담을 고려해볼 시기입니다.';
      if (score <= 19) return '중증도의 우울 증상을 보이고 있습니다. 전문가의 도움이 필요할 수 있습니다.';
      return '심각한 수준의 우울 증상이 의심됩니다. 반드시 전문가와 상담하시기 바랍니다.';

    case 'gad-7':
      if (score <= 4) return '불안 증상이 거의 없거나 최소한의 수준입니다.';
      if (score <= 9) return '경미한 불안 증상을 보이고 있습니다. 일상생활에 미치는 영향을 관찰해보세요.';
      if (score <= 14) return '중간 수준의 불안 증상이 의심됩니다. 불안을 관리할 방법을 찾아보는 것이 좋습니다.';
      return '심각한 수준의 불안 증상이 의심됩니다. 전문가의 도움이 필요합니다.';

    case 'pss':
      if (score <= 13) return '낮은 수준의 스트레스를 받고 있습니다. 현재 상태를 잘 유지하세요.';
      if (score <= 26) return '중간 수준의 스트레스를 받고 있습니다. 스트레스 해소 방법을 찾아보는 것이 좋습니다.';
      return '높은 수준의 스트레스를 받고 있습니다. 전문가의 도움을 받아 스트레스 관리가 필요합니다.';

    case 'rses':
      if (score <= 14) return '자존감이 낮은 수준입니다. 자신을 긍정적으로 바라보는 연습이 필요합니다.';
      if (score <= 25) return '보통 수준의 자존감을 가지고 있습니다. 자신에 대한 믿음을 키워나가세요.';
      return '높은 수준의 자존감을 가지고 있습니다. 건강한 자존감을 잘 유지하고 있습니다.';

    case 'pcl-5':
      if (score <= 31) return '외상 후 스트레스 증상이 거의 없거나 임상적으로 유의미하지 않은 수준입니다.';
      if (score <= 37) return '외상 후 스트레스 증상(PTSD) 가능성이 있습니다. 전문가와 상담을 고려해보세요.';
      return '외상 후 스트레스 증상(PTSD)이 의심되는 높은 수준의 점수입니다. 반드시 전문가의 도움이 필요합니다.';

    case 'bdi':
      if (score <= 9) return '우울하지 않은 상태이거나, 우울 증상이 거의 없는 최소한의 수준입니다.';
      if (score <= 15) return '가벼운 우울 상태(경도 우울)를 보이고 있습니다. 기분 변화에 주의를 기울여보세요.';
      if (score <= 23) return '중간 수준의 우울 상태(중등도 우울)가 의심됩니다. 전문가 상담을 고려해볼 수 있습니다.';
      return '심각한 수준의 우울 상태가 의심됩니다. 반드시 전문가와 상담하여 도움을 받으시기 바랍니다.';

    default:
      return '알 수 없는 검사입니다.';
  }
};
